module.exports = __webpack_public_path__ + "static/media/rain.214ff9e3.svg";